import { render, staticRenderFns } from "./FriendVolunteerStandardDetails.vue?vue&type=template&id=0171faaa"
import script from "./FriendVolunteerStandardDetails.vue?vue&type=script&lang=ts"
export * from "./FriendVolunteerStandardDetails.vue?vue&type=script&lang=ts"
import style0 from "./FriendVolunteerStandardDetails.vue?vue&type=style&index=0&id=0171faaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports